import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/imacm1red/Documents/pione-group-v2/src/components/pages/home/index.tsx");
